export const organization = {
  id: 'org_3la_labs',
  legalName: '3LA Labs Tecnologia Ltda',
  fantasyName: '3LA Labs',
  document: '45.678.901/0001-23',
  municipalRegistration: '12345678',
  email: 'contato@3lalabs.com.br',
  phone: '11987654321',
  address: 'Av. Paulista, 1000 — Conjunto 101',
  city: 'São Paulo',
  state: 'SP',
  zipCode: '01310-100',
};

export const clients = [
  {
    id: 'cli_xpto',
    organizationId: 'org_3la_labs',
    personType: 'PJ',
    name: 'Empresa XPTO Tecnologia Ltda',
    fantasyName: 'XPTO Tecnologia',
    document: '12.345.678/0001-90',
    stateRegistration: '10.20.30.405',
    municipalRegistration: '9876543',
    email: 'financeiro@xptotec.com.br',
    phone: '1130001122',
    mobile: '11999887766',
    contactName: 'Ana Souza',
    contactEmail: 'ana.souza@xptotec.com.br',
    contactPhone: '11999887766',
    zipCode: '04547-130',
    street: 'Rua das Inovações',
    number: '250',
    complement: 'Sala 42',
    neighborhood: 'Vila Olímpia',
    city: 'São Paulo',
    state: 'SP',
    notes: 'Cliente prioritário — faturamento mensal via NFS-e.',
    status: 'Ativo',
    lastActivity: '04/09/2026',
    totalBilled: 48500,
    openAmount: 2500,
    receivedAmount: 46000,
    overdueAmount: 0,
  },
  {
    id: 'cli_emsoft',
    organizationId: 'org_3la_labs',
    personType: 'PJ',
    name: 'Emsoft Solutions Ltda',
    fantasyName: 'Emsoft',
    document: '23.456.789/0001-01',
    stateRegistration: 'ISENTO',
    municipalRegistration: '1122334',
    email: 'contato@emsoft.com.br',
    phone: '1133445566',
    mobile: '11988776655',
    contactName: 'Carlos Mendes',
    contactEmail: 'carlos@emsoft.com.br',
    contactPhone: '11988776655',
    zipCode: '01451-000',
    street: 'Av. Faria Lima',
    number: '1500',
    complement: 'Andar 8',
    neighborhood: 'Itaim Bibi',
    city: 'São Paulo',
    state: 'SP',
    notes: '',
    status: 'Ativo',
    lastActivity: '02/09/2026',
    totalBilled: 32000,
    openAmount: 4800,
    receivedAmount: 27200,
    overdueAmount: 0,
  },
  {
    id: 'cli_alpha',
    organizationId: 'org_3la_labs',
    personType: 'PJ',
    name: 'Studio Alpha Design Ltda',
    fantasyName: 'Studio Alpha',
    document: '34.567.890/0001-12',
    stateRegistration: '78.90.123.456',
    municipalRegistration: '5566778',
    email: 'ola@studioalpha.com.br',
    phone: '2130004455',
    mobile: '21988776655',
    contactName: 'Beatriz Lima',
    contactEmail: 'beatriz@studioalpha.com.br',
    contactPhone: '21988776655',
    zipCode: '22410-003',
    street: 'Rua Visconde de Pirajá',
    number: '430',
    complement: '',
    neighborhood: 'Ipanema',
    city: 'Rio de Janeiro',
    state: 'RJ',
    notes: 'Preferência por boleto bancário.',
    status: 'Ativo',
    lastActivity: '28/08/2026',
    totalBilled: 18500,
    openAmount: 3200,
    receivedAmount: 15300,
    overdueAmount: 1200,
  },
  {
    id: 'cli_horizonte',
    organizationId: 'org_3la_labs',
    personType: 'PJ',
    name: 'Agência Horizonte Comunicação Ltda',
    fantasyName: 'Horizonte',
    document: '56.789.012/0001-34',
    stateRegistration: '90.123.456-78',
    municipalRegistration: '3344556',
    email: 'financeiro@agenciahorizonte.com.br',
    phone: '4130007788',
    mobile: '41977665544',
    contactName: 'Diego Rocha',
    contactEmail: 'diego@agenciahorizonte.com.br',
    contactPhone: '41977665544',
    zipCode: '80020-310',
    street: 'Rua XV de Novembro',
    number: '700',
    complement: 'Conj. 1201',
    neighborhood: 'Centro',
    city: 'Curitiba',
    state: 'PR',
    notes: '',
    status: 'Ativo',
    lastActivity: '01/09/2026',
    totalBilled: 27400,
    openAmount: 5420,
    receivedAmount: 21980,
    overdueAmount: 0,
  },
  {
    id: 'cli_norte',
    organizationId: 'org_3la_labs',
    personType: 'PF',
    name: 'Marcos Oliveira Silva',
    fantasyName: 'Norte Digital',
    document: '123.456.789-09',
    stateRegistration: '',
    municipalRegistration: '',
    email: 'admin@nortedigital.com.br',
    phone: '8530001122',
    mobile: '85966554433',
    contactName: 'Marcos Oliveira',
    contactEmail: 'admin@nortedigital.com.br',
    contactPhone: '85966554433',
    zipCode: '60165-121',
    street: 'Av. Beira Mar',
    number: '1200',
    complement: 'Apto 501',
    neighborhood: 'Meireles',
    city: 'Fortaleza',
    state: 'CE',
    notes: 'MEI — cadastro como pessoa física.',
    status: 'Inativo',
    lastActivity: '12/06/2026',
    totalBilled: 8200,
    openAmount: 0,
    receivedAmount: 8200,
    overdueAmount: 0,
  },
];
